import Vue from "vue";
import Vuex from 'vuex';
import rootMutations from "@/store/mutations.js";
import rootGetters from "@/store/getters.js";
import PositionsModule from "@/store/modules/positions";
import InstructionsModule from "@/store/modules/instructions";
import WarningsModule from "@/store/modules/warnings";
import TeamSuitabilityModule from "@/store/modules/teamSuitability";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},

  modules: {
    positions: PositionsModule,
    instructions: InstructionsModule,
    warnings: WarningsModule,
    teamSuitability: TeamSuitabilityModule,
  },

  mutations: rootMutations,

  getters: rootGetters
});

export default store;
